export default __webpack_public_path__ + "static/media/skills-of-future.a4a941d2.png";